import React from 'react';
import AutocompleteGruppo from './autocompleteGruppo';
const TeamData = ({ teamData, errors, onTeamDataChange, onLogoUpload, onRemoveLogo, isEditMode = false, mostraCibo = true, preiscrizione = false, onPreiscrizioneSubmit, isSubmitting = false, gruppiScout = [], bloccato = false }) => {
  const handleLogoClick = () => {
    if (bloccato) return;
    document.getElementById('logoInput').click();
  };

  return (
    <div className="inscription-form-section">
      <div className="inscription-section-header">
        <i className="fas fa-users"></i>
        <h2>Dati Squadra</h2>
        {isEditMode && (
          <span style={{marginLeft: 'auto', fontSize: '0.8rem', fontWeight: 'normal'}}>
            <i className="fas fa-edit"></i> Modalità modifica
          </span>
        )}
      </div>
      <div className="inscription-section-content">
        <div className="inscription-team-layout">
          {/* Logo a sinistra */}
          <div className={`inscription-form-group ${errors.logo ? 'error' : ''}`}>
            <label>Logo Squadra</label>
            {!teamData.logo ? (
              <div className="inscription-logo-upload-square" onClick={handleLogoClick}>
                <input
                  type="file"
                  id="logoInput"
                  accept="image/png"
                  onChange={onLogoUpload}
                  disabled={bloccato}
                />
                <div className="inscription-logo-upload-content">
                  <i className="fas fa-cloud-upload-alt"></i>
                  <div className="inscription-logo-upload-text">
                    <strong>Clicca per caricare</strong>
                  </div>
                  <small>PNG, max 2MB</small>
                  <small>800x800 pixel</small>
                </div>
              </div>
            ) : (
              <div className="inscription-logo-preview-square">
                <img src={teamData.logo.preview} alt="Logo preview" />
                <button
                  type="button"
                  className="inscription-logo-remove-square"
                  onClick={onRemoveLogo}
                  title="Rimuovi logo"
                  disabled={bloccato}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            )}
            {errors.logo && (
              <span className="inscription-error-message">{errors.logo}</span>
            )}
          </div>

          {/* Dati squadra a destra in formato tabella */}
          <div className="inscription-team-data">
            <table className="inscription-team-table">
              <tbody>
                <tr className={errors.maglia ? 'error' : ''}>
                  <td className="inscription-table-label">
                    <label htmlFor="maglia">
                      Nome Squadra <span className="required">*</span>
                      {isEditMode && (
                        <span style={{color: '#7f8c8d', fontSize: '0.7rem', fontWeight: 'normal', display: 'block'}}>(modificabile)</span>
                      )}
                    </label>
                  </td>
                  <td className="inscription-table-field">
                    <input
                      type="text"
                      id="maglia"
                      value={teamData.maglia}
                      onChange={(e) => onTeamDataChange('maglia', e.target.value)}
                      placeholder="Nome della squadra"
                      disabled={bloccato}
                    />
                    {errors.maglia && (
                      <span className="inscription-error-message">{errors.maglia}</span>
                    )}
                  </td>
                </tr>

                <tr className={errors.gruppoScout ? 'error' : ''}>
                  <td className="inscription-table-label">
                    <label htmlFor="gruppoScout">
                      Gruppo Scout <span className="required">*</span>
                      {isEditMode && (
                        <span style={{color: '#7f8c8d', fontSize: '0.7rem', fontWeight: 'normal', display: 'block'}}>(modificabile)</span>
                      )}
                    </label>
                  </td>
                  <td className="inscription-table-field">
                    <AutocompleteGruppo
                      value={teamData.gruppoScoutText || ''}
                      onChange={(text, id) => {
                        onTeamDataChange('gruppoScoutText', text);
                        if (id) {
                          onTeamDataChange('gruppoScout', id);
                        } else {
                          const match = gruppiScout.find(g => g.name === text);
                          onTeamDataChange('gruppoScout', match ? match.id : null);
                        }
                      }}
                      gruppiScout={gruppiScout}
                      placeholder="Cerca gruppo scout..."
                      disabled={bloccato}
                    />
                    {errors.gruppoScout && (
                      <span className="inscription-error-message">{errors.gruppoScout}</span>
                    )}
                  </td>
                </tr>

                <tr className={errors.contatto ? 'error' : ''}>
                  <td className="inscription-table-label">
                    <label htmlFor="contatto">
                      Contatto Telefonico <span className="required">*</span>
                      {isEditMode && (
                        <span style={{color: '#7f8c8d', fontSize: '0.7rem', fontWeight: 'normal', display: 'block'}}>(modificabile)</span>
                      )}
                    </label>
                  </td>
                  <td className="inscription-table-field">
                    <input
                      type="tel"
                      id="contatto"
                      value={teamData.contatto}
                      onChange={(e) => onTeamDataChange('contatto', e.target.value)}
                      placeholder="3491236547"
                      disabled={bloccato}
                    />
                    {errors.contatto && (
                      <span className="inscription-error-message">{errors.contatto}</span>
                    )}
                  </td>
                </tr>

                {mostraCibo && (
                  <>
                    <tr><td> </td></tr>

                    <tr className={errors.accompagnatori ? 'error' : ''}>
                      <td className="inscription-table-label">
                        <label htmlFor="accompagnatori">
                          Numero Accompagnatori
                          {isEditMode && (
                            <span style={{color: '#7f8c8d', fontSize: '0.7rem', fontWeight: 'normal', display: 'block'}}>(modificabile)</span>
                          )}
                        </label>
                      </td>
                      <td className="inscription-table-field">
                        <input
                          type="number"
                          id="accompagnatori"
                          value={teamData.accompagnatori || ''}
                          onChange={(e) => onTeamDataChange('accompagnatori', e.target.value)}
                          placeholder="0"
                          min="0"
                          max="10"
                          disabled={bloccato}
                        />
                        {errors.accompagnatori && (
                          <span className="inscription-error-message">{errors.accompagnatori}</span>
                        )}
                      </td>
                    </tr>

                    <tr className={errors.vegetariani ? 'error' : ''}>
                      <td className="inscription-table-label">
                        <label htmlFor="vegetariani">
                          Numero Vegetariani
                          {isEditMode && (
                            <span style={{color: '#7f8c8d', fontSize: '0.7rem', fontWeight: 'normal', display: 'block'}}>(modificabile)</span>
                          )}
                        </label>
                      </td>
                      <td className="inscription-table-field">
                        <input
                          type="number"
                          id="vegetariani"
                          value={teamData.vegetariani || ''}
                          onChange={(e) => onTeamDataChange('vegetariani', e.target.value)}
                          placeholder="0"
                          min="0"
                          max="20"
                          disabled={bloccato}
                        />
                        {errors.vegetariani && (
                          <span className="inscription-error-message">{errors.vegetariani}</span>
                        )}
                      </td>
                    </tr>

                    <tr className={errors.vegani ? 'error' : ''}>
                      <td className="inscription-table-label">
                        <label htmlFor="vegani">
                          Numero Vegani
                          {isEditMode && (
                            <span style={{color: '#7f8c8d', fontSize: '0.7rem', fontWeight: 'normal', display: 'block'}}>(modificabile)</span>
                          )}
                        </label>
                      </td>
                      <td className="inscription-table-field">
                        <input
                          type="number"
                          id="vegani"
                          value={teamData.vegani || ''}
                          onChange={(e) => onTeamDataChange('vegani', e.target.value)}
                          placeholder="0"
                          min="0"
                          max="20"
                          disabled={bloccato}
                        />
                        {errors.vegani && (
                          <span className="inscription-error-message">{errors.vegani}</span>
                        )}
                      </td>
                    </tr>

                    <tr className={errors.celiaci ? 'error' : ''}>
                      <td className="inscription-table-label">
                        <label htmlFor="celiaci">
                          Numero Celiaci
                          {isEditMode && (
                            <span style={{color: '#7f8c8d', fontSize: '0.7rem', fontWeight: 'normal', display: 'block'}}>(modificabile)</span>
                          )}
                        </label>
                      </td>
                      <td className="inscription-table-field">
                        <input
                          type="number"
                          id="celiaci"
                          value={teamData.celiaci || ''}
                          onChange={(e) => onTeamDataChange('celiaci', e.target.value)}
                          placeholder="0"
                          min="0"
                          max="20"
                          disabled={bloccato}
                        />
                        {errors.celiaci && (
                          <span className="inscription-error-message">{errors.celiaci}</span>
                        )}
                      </td>
                    </tr>

                    <tr className={errors.altreIntolleranze ? 'error' : ''}>
                      <td className="inscription-table-label">
                        <label htmlFor="altreIntolleranze">
                          Altre Intolleranze
                          {isEditMode && (
                            <span style={{color: '#7f8c8d', fontSize: '0.7rem', fontWeight: 'normal', display: 'block'}}>(modificabile)</span>
                          )}
                        </label>
                      </td>
                      <td className="inscription-table-field">
                        <textarea
                          id="altreIntolleranze"
                          value={teamData.altreIntolleranze || ''}
                          onChange={(e) => onTeamDataChange('altreIntolleranze', e.target.value)}
                          placeholder="Specificare altre intolleranze alimentari..."
                          rows="3"
                          maxLength="500"
                          disabled={bloccato}
                        />
                        {errors.altreIntolleranze && (
                          <span className="inscription-error-message">{errors.altreIntolleranze}</span>
                        )}
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>

            {preiscrizione && !isEditMode && (
              <div style={{ marginTop: '1rem' }}>
                <button
                  type="button"
                  onClick={onPreiscrizioneSubmit}
                  disabled={isSubmitting || bloccato}
                  style={{
                    width: '100%',
                    padding: '0.75rem 1.5rem',
                    backgroundColor: '#28a745',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    cursor: isSubmitting ? 'not-allowed' : 'pointer',
                    opacity: isSubmitting ? 0.6 : 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem',
                    position: 'relative'
                  }}
                >
                  {isSubmitting ? (
                    <>
                      <div className="inscription-loading-spinner"></div>
                      Invio in corso...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-paper-plane"></i>
                      Invia Preiscrizione (senza giocatori)
                      <i
                        className="fas fa-info-circle"
                        style={{ marginLeft: '0.5rem' }}
                        title="Puoi inviare la preiscrizione anche senza inserire i giocatori. Potrai aggiungerli successivamente."
                      ></i>
                    </>
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamData;
